import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const LogoImage = () => {
  const query = useStaticQuery(
    graphql`
      query {
        file(relativePath: { eq: "logo-shadow.png" }) {
          childImageSharp {
            fixed(width: 172, height: 180, quality: 100) {
              ...GatsbyImageSharpFixed
            }
          }
        }
      }
    `
  )

  return <Img fixed={query.file.childImageSharp.fixed} />
}

export default LogoImage